import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function StockMovingDistInt() {
    const [formData, setFormData] = useState({
        from_fps: '',
        to_fps: '',
        month: '',
        year: '',
        remarks: ''
    });
    const [stockData, setStockData] = useState([]);
    const [message, setMessage] = useState('');
    const [listSize, setListSize] = useState(0);

    const monthNames = [
        '',
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/stock-moving-dist/current-month-year-dist`, { withCredentials: true })
            .then(response => {
                setFormData(prev => ({
                    ...prev,
                    month: response.data.month,
                    year: response.data.year
                }));
            })
            .catch(error => {
                setMessage('Failed to fetch month/year. Please check your connection.');
            });
    }, []);
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleStockChange = useCallback((index, value) => {
        const newStockData = [...stockData];
        const parsedValue = parseFloat(value) || 0;
        if (parsedValue > parseFloat(newStockData[index].cb)) {
            alert("Moved Stock More than CB");
            newStockData[index].update_qty = '0';
        } else {
            newStockData[index].update_qty = value;
        }
        setStockData(newStockData);
    }, [stockData]);

    const handleFetchStock = useCallback(async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/stock-moving-dist/getdetails`, formData, { withCredentials: true });
            setStockData(response.data.list.map(item => ({ ...item, update_qty: '0' })));
            setListSize(response.data.list_size);
            setMessage(response.data.msg || '');
        } catch (error) {
            setMessage('Error fetching stock details. Please try again.');
        }
    }, [formData]);

    const handleStockUpdate = useCallback(async (e) => {
        e.preventDefault();

        try {
            if (stockData.length === 0) {
                setMessage("No stock data to update.");
                return;
            }

            // Prepare JSON payload
            const payload = {
                from_fps: stockData[0]?.from_fps || formData.from_fps,
                to_fps: formData.to_fps,
                month: formData.month,
                year: formData.year,
                remarks: formData.remarks,
                comm_code: stockData.map(item => item.comm_code),
                update_qty: stockData.map(item => item.update_qty)
            };

            console.log("Sending payload:", payload);

            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/stock-moving-dist/stockupdate`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-React-Route": window.location.href,
                    },
                    withCredentials: true,
                }
            );


            setMessage(response.data.message || "Stock updated successfully");

            if (response.data.message?.toLowerCase().includes("success")) {
                // Reset form after success
                setStockData([]);
                setListSize(0);
                setFormData(prev => ({
                    ...prev,
                    from_fps: "",
                    to_fps: "",
                    remarks: ""
                }));
            }
        } catch (error) {
            console.error("Error:", error);
            setMessage("Error updating stock. Please try again.");
        }
    }, [formData, stockData]);


    return (
        <div className="container mx-auto p-4 max-w-4xl">

            <form onSubmit={handleFetchStock} className="w-3/4 mx-auto mb-8">
                <table className="w-full border-collapse border border-gray-300 bg-white shadow-md">
                    <thead>
                        <tr className="tableheader">
                            <th colSpan={6} className="p-2 text-lg">Stock Moving from One FPS to Another</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="text-sm">
                            <td className="border p-2">From FPS ID</td>
                            <td className="border p-2">
                                <input
                                    type="text"
                                    name="from_fps"
                                    value={formData.from_fps}
                                    onChange={handleInputChange}
                                    onMouseOver={(e) => e.target.select()}
                                    className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </td>
                            <td className="border p-2">Month</td>
                            <td className="border p-2">
                                <select
                                    name="month"
                                    value={formData.month}
                                    onChange={handleInputChange}
                                    className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                                    disabled
                                >
                                    <option value={formData.month}>{monthNames[formData.month]}</option>
                                </select>
                            </td>

                            <td className="border p-2">Year</td>
                            <td className="border p-2">
                                <select
                                    name="year"
                                    value={formData.year}
                                    onChange={handleInputChange}
                                    className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    disabled
                                >
                                    <option value={formData.year}>{formData.year}</option>
                                </select>
                            </td>
                        </tr>
                        <tr className="text-sm">
                            <td className="border p-2">Target FPS ID</td>
                            <td className="border p-2">
                                <input
                                    type="text"
                                    name="to_fps"
                                    value={formData.to_fps}
                                    onChange={handleInputChange}
                                    onMouseOver={(e) => e.target.select()}
                                    className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </td>
                            <td className="border p-2" colSpan={2}>Remarks</td>
                            <td className="border p-2" colSpan={2}>
                                <input
                                    type="text"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                    onMouseOver={(e) => e.target.select()}
                                    className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={6} className="text-center p-2">
                                <button
                                    type="submit"
                                    className="tableheader"
                                >
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setFormData(prev => ({ ...prev, from_fps: '', to_fps: '', remarks: '' }))}
                                    className="tableheader  ml-2"
                                >
                                    Back
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>


            {message && (
                <div className="text-center text-red-500 mb-4 font-semibold">{message}</div>
            )}

            {listSize > 0 && (
                <form onSubmit={handleStockUpdate} className="w-full mx-auto overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300 bg-white shadow-md">
                        <thead>
                            <tr>
                                <td colSpan={3} className="border p-2 font-semibold bg-gray-100 text-center">
                                    Select Month
                                </td>
                                <td colSpan={2} className="border p-2">
                                    <input
                                        type="text"
                                        value={monthNames[formData.month]}
                                        readOnly
                                        className="w-full p-1 border rounded bg-white text-black"
                                    />

                                </td>
                                <td colSpan={2} className="border p-2 font-semibold bg-gray-100 text-center">
                                    Select Year
                                </td>
                                <td colSpan={2} className="border p-2">
                                    <input
                                        type="text"
                                        value={formData.year}
                                        readOnly
                                        className="w-full p-1 border rounded bg-white text-black"
                                    />


                                    <input type="hidden" value={formData.to_fps} name="to_fps" />
                                    <input type="hidden" value={formData.remarks} name="remarks" />
                                </td>
                            </tr>
                            <tr className="tableheader">
                                <th className="border p-2 w-1/12">Sl No</th>
                                <th className="border p-2 w-2/12">Commodity</th>
                                <th className="border p-2 w-1/12">OB</th>
                                <th className="border p-2 w-1/12">Received</th>
                                <th className="border p-2 w-1/12">Extra RO</th>
                                <th className="border p-2 w-1/12">Six A</th>
                                <th className="border p-2 w-1/12">Sale</th>
                                <th className="border p-2 w-1/12">CB</th>
                                <th className="border p-2 w-2/12">Stock to Move</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stockData.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50 text-sm">
                                    <td className="border p-1 text-center">{index + 1}</td>
                                    <td className="border p-1 truncate">{item.comm_name_eng}</td>
                                    <td className="border p-1 text-right">{item.ob.toFixed(3)}</td>
                                    <td className="border p-1 text-right">{item.received_qty.toFixed(3)}</td>
                                    <td className="border p-1 text-right">{item.extra_ro.toFixed(3)}</td>
                                    <td className="border p-1 text-right">{item.sixi.toFixed(3)}</td>
                                    <td className="border p-1 text-right">{item.issued_qty.toFixed(3)}</td>
                                    <td className="border p-1 text-right bg-gray-100">
                                        <input
                                            type="text"
                                            value={item.cb.toFixed(3)}
                                            readOnly
                                            className="w-full text-right border-0 bg-gray-100 focus:outline-none p-1"
                                        />
                                    </td>
                                    <td className="border p-1">
                                        <input
                                            type="text"
                                            value={item.update_qty}
                                            onChange={(e) => handleStockChange(index, e.target.value)}
                                            onClick={(e) => e.target.select()}
                                            className="w-full p-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="mt-4 flex justify-center">
                        <button
                            type="submit"
                            className="tableheader"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            )}

        </div>
    );
}

export default StockMovingDistInt;